import { render } from "./Select.vue?vue&type=template&id=f472ed18"
import script from "./Select.vue?vue&type=script&lang=js"
export * from "./Select.vue?vue&type=script&lang=js"

import "./Select.vue?vue&type=style&index=0&id=f472ed18&lang=scss"
script.render = render

export default script